module.exports = __webpack_public_path__ + "static/media/TasklyPersonas.e9964bd0.png";